import {Component, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {fixturesAllowed} from './fixtures-environment';
import {FixturesEventsService} from './fixtures-events.service';
import {FIXTURE_DEFINITIONS} from './fixtures.registry';
import {FixtureDefinition} from './fixtures.types';

@Component({
  selector: 'app-fixtures-modal',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatFormFieldModule, MatSelectModule, MatProgressSpinnerModule],
  templateUrl: './fixtures-modal.component.html',
  styles: [`
    :host { display: flex; flex-direction: column; max-height: 95vh; overflow: hidden; }
    .selection { padding: 0 24px 8px; }
    mat-form-field { width: 100%; }
    .environment { margin: 0 0 16px; font-size: 12px; overflow-wrap: anywhere; }
    .error { color: #b71c1c; }
    .loading { display: flex; align-items: center; gap: 12px; }
    p { margin: 8px 0 16px; }
  `],
})
export class FixturesModalComponent implements OnDestroy {
  @ViewChild('generatorHost', {read: ViewContainerRef, static: true}) host: ViewContainerRef;
  readonly enabled = fixturesAllowed(environment);
  readonly environmentName = environment.name;
  readonly apiUrl = environment.baseApiUrl;
  readonly definitions = FIXTURE_DEFINITIONS;
  selected: FixtureDefinition | null = null;
  loading = false;
  busy = false;
  hasResult = false;
  hasGenerator = false;
  error = '';
  private destroyed = false;
  private generatorSubscriptions = new Subscription();

  constructor(private dialogRef: MatDialogRef<FixturesModalComponent>, private events: FixturesEventsService) {}

  async selectFixture(id: string): Promise<void> {
    if (!this.enabled || this.loading || this.busy || this.hasResult) return;
    const definition = this.definitions.find(entry => entry.id === id);
    if (!definition) return;
    this.selected = definition;
    this.loading = true;
    this.error = '';
    this.hasGenerator = false;
    this.generatorSubscriptions.unsubscribe();
    this.generatorSubscriptions = new Subscription();
    this.host.clear();
    try {
      const component = await definition.loadComponent();
      if (this.destroyed) return;
      const generator = this.host.createComponent(component);
      this.generatorSubscriptions.add(generator.instance.busyChange.subscribe(busy => {
        this.busy = busy;
        this.dialogRef.disableClose = busy;
      }));
      this.generatorSubscriptions.add(generator.instance.created.subscribe(event => {
        this.hasResult = true;
        this.events.notifyCreated(event);
      }));
      this.hasGenerator = true;
    } catch (_error) {
      if (!this.destroyed) this.error = 'Generátor se nepodařilo načíst. Zkuste to znovu.';
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.generatorSubscriptions.unsubscribe();
  }
}
